module.exports = __webpack_public_path__ + "img/slider-1.76921a60.jpg";